// Los filtros de la lista de jugadores viven en la URL y no en el estado del
// componente: al abrir una ficha la lista se desmonta, y sin esto regresar la dejaba
// limpia. De paso, una lista filtrada se puede mandar por WhatsApp.

export const FILTROS_DEFAULT = {
  q: '',
  anios: [],
  estatus: 'todos',
  rama: 'todas',
  grupo: 'todos',
  tipo: 'todos',
}

const ESTATUS_VALIDOS = ['todos', 'activo', 'pendiente', 'inactivo', 'suspendido']
const RAMAS_VALIDAS = ['todas', 'varonil', 'femenil']

const unoDe = (valor, validos, porOmision) => (validos.includes(valor) ? valor : porOmision)

// "2012,2013" -> [2012, 2013]. Lo que no sea un ano de cuatro digitos se tira.
const leerAnios = (crudo) => String(crudo || '')
  .split(',')
  .map((p) => Number(p.trim()))
  .filter((n) => Number.isInteger(n) && n >= 1900 && n <= 2200)

export const leerFiltros = (searchParams) => {
  const get = (k) => searchParams.get(k) || ''
  return {
    q: get('q'),
    anios: leerAnios(get('anios')),
    estatus: unoDe(get('estatus'), ESTATUS_VALIDOS, FILTROS_DEFAULT.estatus),
    rama: unoDe(get('rama'), RAMAS_VALIDAS, FILTROS_DEFAULT.rama),
    // grupo y tipo (deporte) son dinamicos: dependen de lo que la org tenga cargado,
    // asi que aqui pasan tal cual y PlayersManager los sanea cuando ya sabe que
    // grupos y que deportes existen.
    grupo: get('grupo') || FILTROS_DEFAULT.grupo,
    tipo: get('tipo') || FILTROS_DEFAULT.tipo,
  }
}

// Un filtro en su valor por omision NO aparece en la URL: nada de ?estatus=todos.
export const escribirFiltros = (filtros = {}) => {
  const params = new URLSearchParams()
  const f = { ...FILTROS_DEFAULT, ...filtros }
  if (f.q) params.set('q', f.q)
  if (f.anios?.length) params.set('anios', f.anios.join(','))
  if (f.estatus !== FILTROS_DEFAULT.estatus) params.set('estatus', f.estatus)
  if (f.rama !== FILTROS_DEFAULT.rama) params.set('rama', f.rama)
  if (f.grupo !== FILTROS_DEFAULT.grupo) params.set('grupo', f.grupo)
  if (f.tipo !== FILTROS_DEFAULT.tipo) params.set('tipo', f.tipo)
  return params
}
